import Footer from "@/components/footer/footer";
import EllipseLeft from "@/assets/EllipseLeft.svg";
import EllipseRight from "@/assets/Ellipse 2-3.svg";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Benefits } from "./components/Benefits";
import { Cases } from "./components/Cases";
import { Clients } from "./components/Clients";
import { Contact } from "./components/Contact";

export function HomePage() {
  return (
    <div className="relative overflow-hidden pb-16">
      <div className="pointer-events-none absolute inset-0">
        <img src={EllipseLeft} alt="" className="absolute -left-30 -top-36 w-180 blur-[300px] opacity-30 dark:opacity-100" aria-hidden />
        <img src={EllipseRight} alt="" className="absolute -right-30 -top-36 w-180 blur-[300px] opacity-30 dark:opacity-100" aria-hidden />
      </div>
      <div className="relative mx-auto flex max-w-6xl flex-col gap-24 px-6 pt-8">
        <Hero />
        <Services />
        <About />
        <Benefits />
        <Cases />
        <Clients />
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
